import { useEffect, useRef } from "react";
import { trackEvent } from "./analytics";

// Keep OAuth query parameters, social handles, account IDs and post contents
// out of the tracker funnel's events, including GA's page-location parameter.
export function trackStatsEvent(name, params = {}) {
  trackEvent(name, { ...params, page_location: `${window.location.origin}/stats`, page_title: "Social Media Stats" });
}

export function trackStatsVisit(signedIn) {
  trackStatsEvent("stats_visit", { signed_in: signedIn });
  try {
    const today = new Date().toISOString().slice(0, 10);
    const previous = window.localStorage.getItem("kre8:stats:last-visit-day");
    if (previous && previous < today) trackStatsEvent("stats_return_visit", { signed_in: signedIn });
    window.localStorage.setItem("kre8:stats:last-visit-day", today);
  } catch { /* Storage restrictions must never prevent use of the tracker. */ }
}

export function useStatsLoaded(platform, data, count, visible) {
  const lastReported = useRef(null);
  useEffect(() => {
    if (!visible || !data || lastReported.current === data) return;
    lastReported.current = data;
    trackStatsEvent("stats_loaded", { platform, item_count: count });
  }, [platform, data, count, visible]);
}
